import { useState,useContext } from "react"
import React from 'react'

const AppContext = React.createContext()

const AppProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [timer, setTimer] = useState(false);
    return (
        <AppContext.Provider
        value={{ loading, setLoading, questions, setQuestions, timer, setTimer}}
        >
          {children}
        </AppContext.Provider>
      )
}

export const useGlobalContext = () => {
    return useContext(AppContext)
  }
  
export { AppContext, AppProvider }